import { motion } from "framer-motion";
import { EXPERIENCE_CHAPTERS } from "@/data/content";

export const Experience = () => (
  <section data-testid="experience-section" className="bg-baseLight px-6 pt-[13px] pb-[30px] sm:py-[40px] lg:px-12 lg:py-[80px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:max-w-none lg:text-center">
        <h2
          data-testid="experience-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
        >
          Engineering. Manufacturing. Integration
        </h2>
      </div>

      <div className="mt-[44px] grid grid-cols-1 divide-y divide-borderLight border-t border-borderLight sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:mt-16 lg:grid-cols-4">
        {EXPERIENCE_CHAPTERS.map((chapter, i) => (
          <motion.div
            key={chapter.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`experience-chapter-${i}`}
            className={`pt-8 ${i === EXPERIENCE_CHAPTERS.length - 1 ? "pb-[12px]" : "pb-8"} sm:px-7 sm:py-10 lg:px-9`}
          >
            <span className="text-xs font-medium uppercase tracking-[0.1em] text-inkMuted">{chapter.title}</span>
            <p className="mt-3 text-base leading-relaxed text-ink">{chapter.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
